module.exports = __webpack_public_path__ + "static/media/scm_logo_0.ad9e032d.png";